import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCustomerRecipeHistoryByIdInput } from './GetCustomerRecipeHistoryByIdInput';
import { GetCustomerRecipeHistoryByIdOutput } from './GetCustomerRecipeHistoryByIdOutput';

export class GetCustomerRecipeHistoryByIdService extends HttpServiceBase {

  handle = (input: GetCustomerRecipeHistoryByIdInput): Promise<Result<GetCustomerRecipeHistoryByIdOutput> | null> => {
    const promise = this.http.get<Result<GetCustomerRecipeHistoryByIdOutput>>(`${this.baseUrlSislogApi}/v2/customer/${input.customerId}/recipe-history`);
    return promise;
  }
}